import {SET_GDPR_CONSENT} from "../actions";

export default function gdprConsentReducer(state = null, action) {
    switch (action.type) {
        case SET_GDPR_CONSENT:
            return action.payload;
        default:
            return state;
    }
}